/**
 * Simple image URL validator that filters out problematic domains
 */

const BLOCKED_DOMAINS = [
  'file.dexlab.space',
  'dexlab.space',
  // Add more as we discover them
];

/**
 * Check if an image URL is likely to be accessible
 * @param url - The image URL to check
 * @returns The URL if valid, undefined if blocked
 */
export function getValidImageUrl(url: string | undefined): string | undefined {
  if (!url) return undefined;

  // Check if it's a data URL or blob (always valid)
  if (url.startsWith('data:') || url.startsWith('blob:')) {
    return url;
  }

  // Check if it's from a blocked domain
  const isBlocked = BLOCKED_DOMAINS.some(domain => url.includes(domain));
  if (isBlocked) {
    console.log(`🚫 Skipping blocked image URL: ${url}`);
    return undefined;
  }

  return url;
}